import { api_POST } from "./_api.js";

const gerenciamentoFiscalizacao_api = {
  ConsultarComInfracao: (json) => {
    const promise = new Promise((resolve, reject) => {
      api_POST("GerenciamentoFiscalizacao/ConsultarComInfracao", json)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  ConsultarSemInfracao: (json) => {
    const promise = new Promise((resolve, reject) => {
      api_POST("GerenciamentoFiscalizacao/ConsultarSemInfracao", json)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  ListarInfracoes: (json) => {
    const promise = new Promise((resolve, reject) => {
      api_POST("GerenciamentoFiscalizacao/ListarInfracoes", json)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  ListarFiscalizacoesSemInfracao: (json) => {
    const promise = new Promise((resolve, reject) => {
      api_POST("GerenciamentoFiscalizacao/ListarFiscalizacoesSemInfracao", json)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  }
}

export default gerenciamentoFiscalizacao_api;
